import { render, staticRenderFns } from "./SymbolX.vue?vue&type=template&id=11be69bc&scoped=true&"
import script from "./SymbolX.vue?vue&type=script&lang=js&"
export * from "./SymbolX.vue?vue&type=script&lang=js&"
import style0 from "./SymbolX.vue?vue&type=style&index=0&id=11be69bc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be69bc",
  null
  
)

export default component.exports